import { render, staticRenderFns } from "./ClientCreator.vue?vue&type=template&id=af0d8ef4&scoped=true&"
import script from "./ClientCreator.vue?vue&type=script&lang=js&"
export * from "./ClientCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af0d8ef4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/advtool/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af0d8ef4')) {
      api.createRecord('af0d8ef4', component.options)
    } else {
      api.reload('af0d8ef4', component.options)
    }
    module.hot.accept("./ClientCreator.vue?vue&type=template&id=af0d8ef4&scoped=true&", function () {
      api.rerender('af0d8ef4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/admin/ClientCreator.vue"
export default component.exports